module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListCage table6"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表 1-6：重点音像制品情况登记表")]) : _c('span', [_vm._v("表 1-6：重点电子出版物情况登记表")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.memberEdit(1)
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ctrlsLine"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过出版物名称查询"
    },
    model: {
      value: (_vm.seekPms.keyword),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "keyword", $$v)
      },
      expression: "seekPms.keyword"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "seekBtn",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.tabSeek('init')
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticClass: "dangerBtns",
    attrs: {
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.memberDet(1)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    staticClass: "dangerBtns",
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": _vm.memberClean
    }
  }, [_vm._v("清除全部")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filterData(_vm.tabDat, _vm.seekPms).slice((_vm.currentPage - 1) * _vm.pageSize, _vm.currentPage * _vm.pageSize),
      "border": ""
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "45"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.$index + 1 + 15 * (_vm.seekPms.no - 1)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "proName",
      "label": "出版物名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "重点出版物名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row, "C021", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "级别",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row, "C024", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ydDate",
      "label": "拟完成时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("stringTrans")(scope.row.ydDate, "time")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(2, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberDet(2, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea"
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.updatedAt),
      callback: function($$v) {
        _vm.updatedAt = $$v
      },
      expression: "updatedAt"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "saveBtn"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.postDeclareFun
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pageArea"
  }, [(_vm.allPage > 1) ? _c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.seekPms.no,
      "page-count": _vm.allPage
    },
    on: {
      "current-change": _vm.goPage
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35b913c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pressRole/Audio_Electronic/forTabs/table6.vue
// module id = 1707
// module chunks = 1